module.exports = __webpack_public_path__ + "img/vizibuzz_logo_new.4b02f4f4.png";